import ModalReject from './modal-reject.component'

export default ModalReject